<template>
  <label class="flex items-center" @change.prevent>
    <slot name="text"> </slot>
    <input
      class="free-radio__input hidden"
      :type="type"
      :name="name"
      :checked="checked"
      :disabled="disabled"
      v-on="extractEventBindings()"
    />
    <div
      class="free-radio relative shrink-0"
      :class="{ hidden: shouldHideOnUncheck && !checked }"
    ></div>
  </label>
</template>

<script setup lang="ts">
  import { useAttrs } from 'vue';

  withDefaults(
    defineProps<{
      name: string;
      shouldHideOnUncheck?: boolean;
      checked?: boolean;
      type?: 'checkbox' | 'radio';
      disabled?: boolean;
      qaId?: string;
    }>(),
    {
      type: 'radio',
      qaId: '',
    },
  );

  function extractEventBindings() {
    const attrs = useAttrs();
    return Object.entries(attrs)
      .filter(([key]) => key.startsWith('on'))
      .reduce((acc, [key, value]) => {
        if (typeof value === 'function') {
          acc[key] = value;
        }
        return acc;
      }, {} as Record<string, unknown>);
  }
</script>

<style scoped>
  .free-radio {
    width: var(--checkbox-width, 20px);
    height: var(--checkbox-height, 20px);
    border-radius: 50%;
    border: 2px solid
      var(--color-checkbox-border, rgb(var(--background-neutral-tertiary)));
  }

  .free-radio::after {
    @apply absolute inset-0 bottom-[3px] m-auto rotate-45 border-transparent;
    border-right-width: var(--checkmark-right-border, 2px);
    border-bottom-width: var(--checkmark-bottom-border, 2px);
    height: var(--checkmark-height, 9px);
    width: var(--checkmark-width, 6px);
    content: '';
  }

  .free-radio__input:checked + .free-radio::after {
    border-bottom-color: var(
      --color-checkbox-checked-border,
      theme('colors.white')
    );
    border-right-color: var(
      --color-checkbox-checked-border,
      theme('colors.white')
    );
  }

  .free-radio__input:checked + .free-radio {
    background-color: var(
      --color-checkbox-checked-border,
      theme('colors.green.500')
    );
    border-color: var(
      --color-checkbox-checked-border,
      theme('colors.green.500')
    );
    transition: background-color 0.2s;
  }
</style>
